import { useState, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import Style from "./AdminsTableStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { FaTrashAlt } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";



export default function AdminsTable(props) {

  //{ admins, onSelectedAdmin, onActionAdmin, loadingAdmin, LoadAdmins }

  const [loading, setLoading] = useState(true);
  const [admins, setAdmins] = useStateIfMounted({} as any);
  const [adminSelected, setAdminSelected] = useState({} as any);
  const [showPopupDeletingAdmin, setShowPopupDeletingAdmin] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [successMessage, setSuccessMessage] = useState<string>();

  useEffect(() => {
    LoadAdmins();
  }, []);

  async function LoadAdmins() {
    setLoading(true);
    try {
      const result = await api.get("/admins");
      if (result.data.success) {
        const admins = result.data.admins;
        setAdmins(admins);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Não pode pegar os admins: ", result.data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Erro pegando admins: ", error);
    }
  }



  async function OnDeleteAdmin() {
    setLoading(true);
    try {
      const result = await api.delete("/admin", {
        data: { id: adminSelected.id, accountId: adminSelected.accountId }
      });
      if (result.data.success) {
        setSuccessMessage("Admin deletado");
      } else {
        setErrorMessage("Problema ao deletar o admin: " + result.data)
      }
      await LoadAdmins();
      ClosePopupDeleteAdmin()
      setLoading(false);
    } catch (error) {
      await LoadAdmins();
      ClosePopupDeleteAdmin();
      setLoading(false);
    }
  }

  function OpenPopupDeleteAdmin(admin) {
    setShowPopupDeletingAdmin(true);
    setAdminSelected(admin);
  }

  function ClosePopupDeleteAdmin() {
    setShowPopupDeletingAdmin(false);
    setAdminSelected({});
  }

  function goGoToEdit(accountId: number) {
    props.history.push(`/admin/${accountId}`)
  }




  if (loading)
    return (<Spinner spinning={loading} />);
  return (
    <Style>
      <PageTitle title="Admins" />
      <TwoButtonsModal
        show={showPopupDeletingAdmin}
        onHide={ClosePopupDeleteAdmin}
        loading={loading}
        title="Deleção de admin!"
        body={`Você tem certeza que deseja deletar o admin de ID: ${adminSelected.id} - Nome: ${adminSelected.name}? Essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeleteAdmin}
        secondaryDisabled={loading}
        primaryText="Deletar"
        primaryOnClick={OnDeleteAdmin}
        primaryDisabled={loading}
      />
      {errorMessage && <p className="alert">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}

      <section className="table-title">
        <h1>Admin</h1>
        <button onClick={() => props.history.push('/admin/0')}>Adicionar Admin</button>
      </section>

      <table className="table table-striped table-bordered table-hover">
        <thead >
          <tr>
            <th>Id</th>
            <th>Nome</th>
            <th>Email</th>
            <th>Job</th>
            <th>Empresa</th>
            <th>Excluir</th>
          </tr>
        </thead>
        <tbody>
          {admins?.length > 0 && admins.map(admin => {
            return (
              <tr key={admin.id}>
                <td onClick={() => goGoToEdit(admin.accountId)} className="clickable">{admin.id}</td>
                <td onClick={() => goGoToEdit(admin.accountId)} className="clickable">{admin.name}</td>
                <td onClick={() => goGoToEdit(admin.accountId)} className="clickable">{admin.email}</td>
                <td onClick={() => goGoToEdit(admin.accountId)} className="clickable">{admin.job}</td>
                <td onClick={() => goGoToEdit(admin.accountId)} className="clickable">{admin.companyName}</td>
                <td >
                  <div className="action" onClick={() => OpenPopupDeleteAdmin(admin)}>
                    <FaTrashAlt className="icon" />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  );
}
